function PendingAuthorization(){
    return(
        <div className={"mt-5 card justify-contents-center text-center"}>
            <h3 className={"card-title"}>Pending Authorization!</h3>
            <div className={"card-body"}>Please check back later! The business team is yet to authorize your registration.<div><button className={"btn btn-primary mt-2"} onClick={()=>{window.location.href="/"}}>Ok</button></div></div>
        </div>
    )
}
export default PendingAuthorization;
